<nz-layout class="app-layout">
  <!-- SIDEBAR -->
  <nz-sider class="menu-sidebar" nzCollapsible [(nzCollapsed)]="isCollapsed" nzBreakpoint="lg">
    <!-- Logo -->
    <div class="sidebar-logo">
      <a [routerLink]="['/dashboard']">
        <h1>{{ isCollapsed ? 'ML' : 'MotLoud' }}</h1>
      </a>
    </div>

    <!-- MENU CONTENT -->
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="main-menu">

      <!-- ========== SECCIÓN EQUIPO ========== -->
      <li nz-menu-group *ngIf="selectedTeam">
        <span title *ngIf="!isCollapsed" class="team-section-header">
          <img
            *ngIf="selectedTeam.logoUrl"
            [src]="selectedTeam.logoUrl"
            [alt]="selectedTeam.name"
            class="team-logo"
          >
          <span class="team-name">{{ selectedTeam.name }}</span>
        </span>
        <span title *ngIf="isCollapsed">
          <img
            *ngIf="selectedTeam.logoUrl"
            [src]="selectedTeam.logoUrl"
            [alt]="selectedTeam.name"
            class="team-logo-collapsed"
          >
        </span>
      </li>
      <li nz-menu-group *ngIf="!selectedTeam">
        <span title *ngIf="!isCollapsed">EQUIPO</span>
      </li>

      <!-- Warning message when no team selected -->
      <ng-container *ngIf="!selectedTeam">
        <li nz-menu-item nzDisabled class="warning-item no-team-warning">
          <i nz-icon nzType="warning" nzTheme="fill"></i>
          <span>Debes seleccionar un equipo</span>
        </li>
        <li nz-menu-item class="select-team-action" (click)="openTeamSelector()">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
          <span>Seleccionar Equipo</span>
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <!-- TEAM CONTEXT MENU (always show structure but disabled when no team) -->
      <ng-container>
        <ng-container *ngFor="let group of teamMenuGroups">
          <!-- Single item groups (no submenu) -->
          <ng-container *ngIf="group.items.length === 1">
            <li
              nz-menu-item
              [nzMatchRouter]="true"
              [routerLink]="group.items[0].link"
              [nzDisabled]="!selectedTeam"
            >
              <i nz-icon [nzType]="group.items[0].icon"></i>
              <span>{{ group.items[0].title }}</span>
            </li>
          </ng-container>v
          <!-- Multi-item groups (with submenu) -->
          <li
            *ngIf="group.items.length > 1"
            nz-submenu
            [nzOpen]="group.expanded"
            (nzOpenChange)="toggleGroup(group)"
            [nzDisabled]="!selectedTeam"
          >
            <span title>
              <i nz-icon [nzType]="group.icon"></i>
              <span>{{ group.name }}</span>
            </span>
            <ul>
              <li
                nz-menu-item
                *ngFor="let item of group.items"
                [nzMatchRouter]="true"
                [routerLink]="item.link"
                [nzDisabled]="!selectedTeam"
              >
                <i nz-icon [nzType]="item.icon"></i>
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </li>
        </ng-container>
      </ng-container>

      <li nz-menu-divider *ngIf="selectedTeam && selectedVehicle"></li>

      <!-- ========== SECCIÓN MOTO (only shown when vehicle selected) ========== -->
      <ng-container *ngIf="selectedTeam && selectedVehicle">
        <li nz-menu-group>
          <span title *ngIf="!isCollapsed">MOTO</span>
        </li>

        <!-- VEHICLE CONTEXT MENU (when vehicle selected) -->
        <ng-container *ngIf="selectedVehicle">
          <!-- Back to Team Button -->
          <li nz-menu-item (click)="onBackToTeam()" class="back-to-team-item">
            <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            <span>Volver al Equipo</span>
          </li>

          <li nz-menu-divider></li>

          <!-- Single condensed menu item for vehicle -->
          <li nz-menu-item [nzMatchRouter]="true" [routerLink]="getVehicleLink('overview')">
            <i nz-icon nzType="car"></i>
            <span>Gestión de Vehículo</span>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </nz-sider>

  <!-- MAIN LAYOUT -->
  <nz-layout [class.sidebar-collapsed]="isCollapsed">
    <!-- HEADER -->
    <nz-header>
      <div class="app-header">
        <!-- Sidebar toggle -->
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>

        <!-- Team and Vehicle Selectors (Compact Dropdowns) -->
        <div class="header-selectors">
          <!-- Team Selector Dropdown -->
          <div class="context-selector">
            <button
              nz-button
              nz-dropdown
              [nzDropdownMenu]="teamMenu"
              nzTrigger="click"
              nzPlacement="bottomLeft"
              [nzDisabled]="loadingTeams"
              [nzLoading]="loadingTeams"
              class="selector-button team-button"
              [class.has-selection]="selectedTeam"
            >
              <i nz-icon nzType="team" nzTheme="outline"></i>
              <span class="selector-text">
                <span class="selector-label">Equipo:</span>
                <span class="selector-value" *ngIf="selectedTeam">{{ selectedTeam.name }}</span>
                <span class="selector-placeholder" *ngIf="!selectedTeam">Seleccionar...</span>
              </span>
              <i nz-icon nzType="down" class="selector-arrow"></i>
            </button>

            <nz-dropdown-menu #teamMenu="nzDropdownMenu">
              <div class="context-dropdown-menu">
                <ul nz-menu class="dropdown-list">
                  <li
                    nz-menu-item
                    *ngFor="let team of teams"
                    (click)="onTeamChange(team.id)"
                    [class.selected-item]="selectedTeam?.id === team.id"
                  >
                    <div class="dropdown-item-content">
                      <div class="item-main">
                        <i nz-icon nzType="team" nzTheme="outline" class="item-icon"></i>
                        <div class="item-info">
                          <span class="item-title">{{ team.name }}</span>
                          <span class="item-subtitle" *ngIf="team.code">{{ team.code }}</span>
                        </div>
                      </div>
                      <i
                        nz-icon
                        nzType="check-circle"
                        nzTheme="fill"
                        class="check-icon"
                        *ngIf="selectedTeam?.id === team.id"
                      ></i>
                    </div>
                  </li>
                </ul>
                <div *ngIf="teams.length === 0" class="dropdown-empty">
                  <i nz-icon nzType="inbox" nzTheme="outline"></i>
                  <span>No hay equipos disponibles</span>
                </div>
                <!-- Create Team Action -->
                <nz-divider style="margin: 4px 0 8px 0;"></nz-divider>
                <div class="dropdown-action">
                  <button
                    nz-button
                    nzType="primary"
                    nzBlock
                    [routerLink]="['/teams']"
                    class="create-action-button"
                  >
                    <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
                    <span>Crear Nuevo Equipo</span>
                  </button>
                </div>
              </div>
            </nz-dropdown-menu>
          </div>

          <!-- Vehicle Selector Dropdown -->
          <div class="context-selector" *ngIf="selectedTeam">
            <button
              nz-button
              nz-dropdown
              [nzDropdownMenu]="vehicleMenu"
              nzTrigger="click"
              nzPlacement="bottomLeft"
              [nzDisabled]="loadingVehicles"
              [nzLoading]="loadingVehicles"
              class="selector-button vehicle-button"
              [class.has-selection]="selectedVehicle"
            >
              <i nz-icon nzType="car" nzTheme="outline"></i>
              <span class="selector-text">
                <span class="selector-label">Moto:</span>
                <span class="selector-value" *ngIf="selectedVehicle">{{ getVehicleDisplayName() }}</span>
                <span class="selector-placeholder" *ngIf="!selectedVehicle">Opcional...</span>
              </span>
              <i nz-icon nzType="down" class="selector-arrow"></i>
            </button>

            <nz-dropdown-menu #vehicleMenu="nzDropdownMenu">
              <div class="context-dropdown-menu">
                <ul nz-menu class="dropdown-list">
                  <li
                    nz-menu-item
                    *ngFor="let vehicle of availableVehicles"
                    (click)="onVehicleSelectById(vehicle.id)"
                    [class.selected-item]="selectedVehicle?.id === vehicle.id"
                  >
                    <div class="dropdown-item-content">
                      <div class="item-main">
                        <i nz-icon nzType="car" nzTheme="outline" class="item-icon"></i>
                        <div class="item-info">
                          <span class="item-title">#{{ vehicle.number }} {{ vehicle.name }}</span>
                          <span class="item-subtitle" *ngIf="vehicle.manufacturer || vehicle.model">
                            {{ vehicle.manufacturer }} {{ vehicle.model }}
                            <span *ngIf="vehicle.year">({{ vehicle.year }})</span>
                          </span>
                        </div>
                      </div>
                      <div class="item-status">
                        <nz-tag
                          [nzColor]="vehicle.status === 'ACTIVE' ? 'success' : 'default'"
                          class="status-badge"
                        >
                          {{ vehicle.status }}
                        </nz-tag>
                        <i
                          nz-icon
                          nzType="check-circle"
                          nzTheme="fill"
                          class="check-icon"
                          *ngIf="selectedVehicle?.id === vehicle.id"
                        ></i>
                      </div>
                    </div>
                  </li>
                </ul>
                <div *ngIf="availableVehicles.length === 0 && !loadingVehicles" class="dropdown-empty">
                  <i nz-icon nzType="inbox" nzTheme="outline"></i>
                  <span>No hay motos disponibles</span>
                </div>
                <!-- Create Vehicle Action -->
                <nz-divider style="margin: 4px 0 8px 0;"></nz-divider>
                <div class="dropdown-action">
                  <button
                    nz-button
                    nzType="primary"
                    nzBlock
                    [routerLink]="['/vehicles']"
                    class="create-action-button"
                  >
                    <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
                    <span>Crear Nueva Moto</span>
                  </button>
                </div>
              </div>
            </nz-dropdown-menu>
          </div>
        </div>

        <!-- Header Right -->
        <div class="header-right">
          <!-- Global Admin Icon -->
          <a
            [routerLink]="['/global-admin']"
            class="header-icon"
            nz-tooltip
            nzTooltipTitle="Administración Global"
          >
            <i nz-icon nzType="setting" nzTheme="outline"></i>
          </a>

          <!-- Home Icon -->
          <a [routerLink]="['/dashboard']" class="header-icon" nz-tooltip nzTooltipTitle="Mi Dashboard">
            <i nz-icon nzType="home" nzTheme="outline"></i>
          </a>

          <!-- Notifications Dropdown -->
          <a nz-dropdown [nzDropdownMenu]="notificationMenu" [nzPlacement]="'bottomRight'" class="header-icon">
            <nz-badge [nzCount]="notificationCount">
              <i nz-icon nzType="bell" nzTheme="outline"></i>
            </nz-badge>
          </a>
          <nz-dropdown-menu #notificationMenu="nzDropdownMenu">
            <div class="notification-dropdown">
              <div class="notification-header">
                <h4>Notificaciones</h4>
              </div>
              <ul nz-menu class="notification-list">
                <li nz-menu-item *ngFor="let notification of notifications" (click)="onNotificationClick(notification)">
                  <div class="notification-item">
                    <div class="notification-content">
                      <strong>{{ notification.title }}</strong>
                      <p>{{ notification.message }}</p>
                      <span class="notification-time">{{ notification.createdAt | date:'short' }}</span>
                    </div>
                    <nz-badge *ngIf="!notification.read" nzStatus="processing"></nz-badge>
                  </div>
                </li>
                <li *ngIf="notifications.length === 0" class="notification-empty">
                  <i nz-icon nzType="inbox" nzTheme="outline"></i>
                  <p>No hay notificaciones</p>
                </li>
              </ul>
              <div class="notification-footer">
                <a [routerLink]="['/notifications']">Ver todas mis notificaciones</a>
              </div>
            </div>
          </nz-dropdown-menu>

          <nz-divider nzType="vertical"></nz-divider>

          <!-- User Dropdown -->
          <a nz-dropdown [nzDropdownMenu]="userMenu" [nzPlacement]="'bottomRight'">
            <nz-avatar [nzText]="currentUser?.firstName?.charAt(0) || 'U'" nzSize="small"></nz-avatar>
            <span class="ml-1">{{ currentUser?.firstName || 'User' }}</span>
            <i nz-icon nzType="down"></i>
          </a>
          <nz-dropdown-menu #userMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item [routerLink]="['/dashboard']">
                <i nz-icon nzType="dashboard"></i> Mi Dashboard
              </li>
              <li nz-menu-item [routerLink]="['/my-teams']">
                <i nz-icon nzType="team"></i> Mis Equipos
              </li>
              <li nz-menu-item [routerLink]="['/profile']">
                <i nz-icon nzType="user"></i> Perfil
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="logout()">
                <i nz-icon nzType="logout"></i> Cerrar Sesión
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </nz-header>

    <!-- CONTENT -->
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>

  <!-- FEEDBACK BUTTON -->
  <app-feedback-button></app-feedback-button>
</nz-layout>
